<template>
  <SectionTemplate
    title="数千款PPT视频模板，一键套用秒出片"
    desc="数千款专业级模板，无论是微课视频、企业内训、办公汇报、产品营销。选好模板、替换PPT，几分钟就能生成专业视频。"
  >
    <div class="container">
      <div class="templates">
        <div v-for="(item, idx) in calList" :key="idx" class="template-item">
          <template v-if="!!item">
            <CardItem
              :data="item"
              :auto-scale="true"
              :source="TEMPLATE_SOURCE.TEMPLATE_PAGE"
              mode="free"
              @cover-click="onHandleCoverClick(item)"
              @preview-click="onHandlePreviewClick(item)"
            >
              {{ item.name }}
            </CardItem>
          </template>
          <template v-else-if="loading">
            <div class="template-item-empty">
              <div class="w-full pt-[56%] max-h-[220px] bg-gray-200 rounded-md"></div>
              <a-skeleton active :paragraph="{ rows: 1 }" />
            </div>
          </template>
        </div>
      </div>
      <StartBtn :handler="handleMore" text="查看更多模板" class="show-more-btn" />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import type { Template } from '@/api/interface';
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import { getTemplateSearch } from '~/api';
import StartBtn from '~/design/components/buttons/start-btn.vue';
import CardItem from '~/features/template/components/cardItem.vue';
import { useTemplateDetail } from '~/hooks/useModal/modals/template';

provideResourceLocation({
  source: SOURCE.TEMPLATE_CENTER,
});

const calList = ref<Template[]>([]);
const loading = ref(false);
const centerTags = useCenterTags();

const pptTag = computed(() => {
  return centerTags.value.tags
    .find(v => v.outer_id === 'industry')
    ?.children?.find(v => v.tag_name === '教育行业'); // 行业标签
});

const onHandleCoverClick = (item: Template) => {
  navigateTo(`/template/${item.id}.html`, { open: { target: '_blank' } });
};

const onHandlePreviewClick = (item: Template) => {
  useTemplateDetail([item], item, {
    templateSource: TEMPLATE_SOURCE.HOMEPAGE,
    source: SOURCE.TEMPLATE_CENTER,
  });
};

const handleMore = () => {
  navigateTo(`/template`, { open: { target: '_blank' } });
};

const resolution = ref('1920x1080');

const fetchTemplateList = async () => {
  loading.value = true;
  const res = await getTemplateSearch({
    page: 1,
    page_size: 12,
    resolution: resolution.value,
    sort_rank: 1,
    is_template_center_template: 1,
    o: 'score',
    platform: 0,
    online_status: 0,
    query_star: true,
    tag_ids: pptTag.value?.ids,
  }).finally(() => {
    loading.value = false;
  });

  calList.value = res.data?.results || [];

  return res;
};

onMounted(async () => {
  await fetchTemplateList();
});
</script>

<style lang="scss" scoped>
.container {
  @apply flex flex-col items-center;
  width: 100%;
}
.templates {
  @apply grid gap-x-[24px] gap-y-[40px];
  grid-template-columns: repeat(4, 1fr);
  width: 100%;

  .template-item {
    &:deep(.card-item) {
      .info,
      .card-item__info {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        color: var(--x-text-3);
        font-size: 16px;
        font-style: normal;
        line-height: normal;
      }
      .card-item__name {
        font-weight: 400;
        color: var(--x-text-3);
      }
      .card-item__tags,
      .card-item__share,
      .card-item__collect {
        display: none;
      }
      .unveil {
        aspect-ratio: 16 / 9;
      }
    }
  }
}
.show-more-btn {
  margin-top: 80px;
  width: 218px !important;
  height: 48px !important;
}
</style>
